import { z } from 'zod';
import { emailSchema } from './common';
import { ROLES } from './enums';
export const inviteMemberSchema = z.object({
    email: emailSchema,
    role: z.enum(ROLES).refine((r) => r !== 'OWNER', 'Ownership is transferred, not invited'),
    workspaceIds: z.array(z.string().uuid()).max(50).default([]),
    message: z.string().max(500).trim().optional(),
});
export const bulkInviteSchema = z.object({
    invitations: z.array(inviteMemberSchema).min(1).max(50),
});
export const changeRoleSchema = z.object({ role: z.enum(ROLES) });
export const MEMBERSHIP_STATUSES = ['PENDING', 'ACTIVE', 'REJECTED'];
/** Approving is also where the newcomer's role is decided. */
export const approveMemberSchema = z.object({
    role: z.enum(ROLES).refine((r) => r !== 'OWNER', 'Ownership is transferred, not granted'),
});
/** Job titles are collected at sign-up; this is how they get corrected later. */
export const changeJobTitleSchema = z.object({
    jobTitle: z.string().max(120).trim().nullable(),
});
//# sourceMappingURL=member.contract.js.map